import { ReactLenis } from "lenis/react";

export const SmoothScroll = ({ children }) => (
  <ReactLenis root options={{ lerp: 0.08, duration: 1.2, smoothWheel: true }}>
    {children}
  </ReactLenis>
);
